<template>
  <div class="CorServiceContent1">
    <div class="left-margin">
    </div>
    <div class="center-content">
      <div class="center-center1">
        <div class="left1">
          <div class="left-content">
            <h2>{{historyData.h1}}</h2>
            <span>{{historyData.sp1}}</span>
            <div class="learn-more">
              <router-link :to="{path:'serviceDetails',query:{num:historyData.num1}}">
                <span>了解详细服务></span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="right1">
          <img src="../../assets/img/cor-zhglxt.png" width="100%"/>
        </div>
      </div>
      <div class="center-center2" :style="historyData.h2?'opacity:1':'opacity:0;display: none;'">
        <div class="left2">
          <img src="../../assets/img/cor-rdznhsj.png" width="100%"/>
        </div>
        <div class="right2">
          <div class="left-content">
            <h2>{{historyData.h2}}</h2>
            <span>{{historyData.sp2}}</span>
            <div class="learn-more">
              <router-link :to="{path:'serviceDetails',query:{num:historyData.num2}}">
                <span>了解详细服务></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="center-center1" :style="historyData.h3?'opacity:1':'opacity:0;display: none;'">
        <div class="left1">
          <div class="left-content">
            <h2>{{historyData.h3}}</h2>
            <span>{{historyData.sp3}}</span>
            <div class="learn-more">
              <router-link :to="{path:'serviceDetails',query:{num:historyData.num3}}">
                <span>了解详细服务></span>
              </router-link>
            </div>
          </div>

        </div>
        <div class="right1">
          <img src="../../assets/img/cor-xtjc.png" width="100%"/>
        </div>
      </div>
      <div class="center-center2" :style="historyData.h4?'opacity:1':'opacity:0;display: none;'">
        <div class="left2">
          <img src="../../assets/img/cor-zhyq.png" width="100%"/>
        </div>
        <div class="right2">
          <div class="left-content">
            <h2>{{historyData.h4}}</h2>
            <span>{{historyData.sp4}}</span>
            <div class="learn-more">
              <router-link :to="{path:'serviceDetails',query:{num:historyData.num4}}">
                <span>了解详细服务></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="center-center1" :style="historyData.h5?'opacity:1':'opacity:0;display: none;'">
        <div class="left1">
          <div class="left-content">
            <h2>{{historyData.h5}}</h2>
            <span>{{historyData.sp5}}</span>
            <div class="learn-more">
              <router-link :to="{path:'serviceDetails',query:{num:historyData.num5}}">
                <span>了解详细服务></span>
              </router-link>
            </div>
          </div>

        </div>
        <div class="right1">
          <img src="../../assets/img/cor-wlw.png" width="100%"/>
        </div>
      </div>
	  <Page :total="dataCount" :page-size="pageSize" @on-change="changepage"/>
    </div>
	
    <div class="right-margin">
    </div>


  </div>
</template>

<script>
  export default {
    data(){
        return {
		  list:[
			  {
				num1:0,
				h1:"综合运维保障服务",
				sp1:"依托我司“综合运维管理系统”产品，结合专业的运维服务团队，向客户提供专业的综合运维服务，助理客户，透明化运维管理，规范运维流程，量化运维工作，提高运维效率，降低运维成本。",
				img1:require("../../assets/img/cor-zhglxt.png"),
				num2:1,
				h2:"弱电智能化设计服务",
				sp2:"以众多智能化设计案例为基础，依托专业的设计团队，遵循国家智能化建筑设计（GB50314-2015）标准，向客户提供专业的弱电智能化设计服务。",
				img2:require("../../assets/img/cor-rdznhsj.png"),
				num3:2,
				h3:"系统集成服务",
				sp3:"以大量系统集成服务案例为基础,依托专业的技术和实施团队,向客户提出专业的IT、信息安全、数据中心和平台等系统集成服务。",
				img3:require("../../assets/img/cor-xtjc.png"),
				num4:3,
				h4:"智慧园区建设咨询服务",
				sp4:"以众多智慧园区建设案例为基础，依托优秀的软件、网络、安全、物联网等领域专业技术团队，向客户提供专业的智慧园区建设咨询服务，助力客户实现园区智能化管理和发展。",
				img4:require("../../assets/img/cor-zhyq.png"),
				num5:4,
				h5:"物联网建设咨询服务",
				sp5:"基于我司“物联网网关”和“物联网综合管理平台”产品，依托专业的网络、智能化和软件团队，向客户提供专业的物联网建设和基于物联网的智能系统建设咨询服务。",
				img5:require("../../assets/img/cor-wlw.png"),
			  },
			  {
				num1:5,
				h1:"锐捷网络产品服务",
				sp1:"湖北锐捷最大的服务商，区域地盘包括武汉，黄冈，咸宁，黄石，宜昌，恩施，鄂州等地。2020全年销售锐捷网络产品4000万，为锐捷优选服务商。",
				img1:require("../../assets/img/cor-zhglxt.png"),
				num2:6,
				h2:"等级保护建设服务咨询服务",
				sp2:"依据等级保护标准对客户信息系统进行等保建设咨询，风险评估、差距分析、规划建设等。",
				img2:require("../../assets/img/cor-rdznhsj.png"),
				num3:7,
				h3:"网络安全驻场运维服务",
				sp3:"网络安全驻场运维服务包括：安全设备维护、策略调整、日常巡检、安全事件处理及响应、知识库的建立与更新等。",
				img3:require("../../assets/img/cor-xtjc.png"),
				num4:8,
				h4:"安全巡检服务",
				sp4:"信息安全是动态的，随着时间的变化会不断暴露出新的安全漏洞、恶意软件、攻击手段，新些将打打破现有信息安全的平衡。",
				img4:require("../../assets/img/cor-zhyq.png"),
				num5:9,
				h5:"安全加固服务",
				sp5:"为了有效保障客户网络的安全运行，需要对操作系统、数据库、中间件、网络设备、安全设备进行安全检测后发现的安全风险进行修复。",
				img5:require("../../assets/img/cor-wlw.png"),
			  },
			  {
			    num1:10,
			    h1:"护网技术支持与重保值守服务",
			    sp1:"在国家重大活动（如国庆、两会等）期间，组织面临的安全攻击呈现攻击力度更大、攻击频率更高、针对性更强等特点。",
			    img1:require("../../assets/img/cor-zhglxt.png"),
			    num2:11,
			    h2:"渗透测试服务",
			    sp2:"由渗透测试工程师模拟黑客对客户的目标应用系统及其宿主服务器进行非破坏性攻击的安全测试、深度漏洞挖掘，发现应用系统隐藏的安全隐患和安全风险，帮助客户提高应用程序的安全性。",
			    img2:require("../../assets/img/cor-rdznhsj.png"),
			    num3:12,
			    h3:"应急响应服务",
			    sp3:"在客户发生信息破坏事件（篡改、泄露、盗窃、丢失等）、大规模病毒事件、Web网站漏洞事件等相关的信息安全事件时，技术专家7*24小时值守，第一时间进行响应，及时采取措施。",
			    img3:require("../../assets/img/cor-xtjc.png"),
			    num4:13,
			    h4:"网络安全培训服务",
			    sp4:"为客户提供网络安全等级保护制度合规咨询一站式服务，同时助力客户网络安全向“实战化、体系化、常态化”提升。",
			    img4:require("../../assets/img/cor-zhyq.png"),
			    num5:14,
			    h5:"等保合规咨询服务",
			    sp5:"针对客户的技术人员、管理人员和其他参与培训的人员提供网络安全培训，包括网络安全意识培训，网络安全技术培训等",
			    img5:require("../../assets/img/cor-wlw.png"),
			  }
			  
		  ],  //接口获取的总数据
		  dataCount:3, // 总数据的条目
		  pageSize:1,     // 每页显示多少条
		  historyData:{				
				num1:0,
				h1:"综合运维保障服务",
				sp1:"依托我司“综合运维管理系统”产品，结合专业的运维服务团队，向客户提供专业的综合运维服务，助理客户，透明化运维管理，规范运维流程，量化运维工作，提高运维效率，降低运维成本。",
				img1:require("../../assets/img/cor-zhglxt.png"),
				num2:1,
				h2:"弱电智能化设计服务",
				sp2:"以众多智能化设计案例为基础，依托专业的设计团队，遵循国家智能化建筑设计（GB50314-2015）标准，向客户提供专业的弱电智能化设计服务。",
				img2:require("../../assets/img/cor-rdznhsj.png"),
				num3:2,
				h3:"系统集成服务",
				sp3:"以大量系统集成服务案例为基础,依托专业的技术和实施团队,向客户提出专业的IT、信息安全、数据中心和平台等系统集成服务。",
				img3:require("../../assets/img/cor-xtjc.png"),
				num4:3,
				h4:"智慧园区建设咨询服务",
				sp4:"以众多智慧园区建设案例为基础，依托优秀的软件、网络、安全、物联网等领域专业技术团队，向客户提供专业的智慧园区建设咨询服务，助力客户实现园区智能化管理和发展。",
				img4:require("../../assets/img/cor-zhyq.png"),
				num5:4,
				h5:"物联网建设咨询服务",
				sp5:"基于我司“物联网网关”和“物联网综合管理平台”产品，依托专业的网络、智能化和软件团队，向客户提供专业的物联网建设和基于物联网的智能系统建设咨询服务。",
				img5:require("../../assets/img/cor-wlw.png"),
				},
        }
    },
	methods:{
	    //页数变化的时候改变每一页的内容
	    changepage(index){
			this.historyData = this.list[index-1];
	    }
	}
  }

</script>

<style lang="less">
	.ivu-page{
		text-align: center;
	}
	
  .CorServiceContent1{
    display: flex;
    border-top-left-radius: 0.1rem;
    border-top-right-radius: 0.1rem;
    .left-margin{
      flex: 1;
    }
    .center-content{
      flex: 8;
      padding-top: 0.3rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      .center-center1{
        margin-bottom: 0.3rem;
        width: 100%;
        background: #FFFFFF;
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        display: flex;
        .left1{
          flex: 2;
          .left-content{
            padding: 0 0.5rem;
            display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
            h2{
              font-size: 30px;
              margin-top: 0.5rem;
              margin-bottom: 0.2rem;

              	font-family: SourceHanSansCN-Regular;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #293347;
            }
            .learn-more{
              display: table;
              padding: 1px 5px;
              // margin-top: 0.7rem;
                  margin-bottom: 0.2rem;
              span{
                              border: #5ac1ff solid 1px;
                color: #5ac1ff;
                padding: 1px;
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
              }
            }
          }
        }
        .right1{
          flex: 1;
          padding: 0.2rem;
        }
      }
      .center-center2{
        margin-bottom: 0.3rem;
        width: 100%;
        background: #FFFFFF;
        border-top-left-radius: 0.1rem;
        border-top-right-radius: 0.1rem;
        display: flex;
        .left2{
          flex: 1;
          padding: 0.2rem;
        }
        .right2{
          flex: 2;
          .left-content{
            padding: 0 0.5rem;
            text-align: right;
            h2{
              font-size: 30px;
              margin-top: 0.5rem;
              margin-bottom: 0.2rem;
            }
            .learn-more{
              padding: 1px 5px;
              margin-top: 0.7rem;
              width: 100%;
              display: flex;
              justify-content: flex-end;
              span{
                border: #5ac1ff solid 1px;
                color: #5ac1ff;
                padding: 1px;
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
              }
            }
          }
        }
      }
    }
    .right-margin{
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cor-service-content/CorServiceContent1.vue